import { myFetchRequestApi } from '@/http/my-fetch';
import type { CurrencyListAo, RegisterFormAo } from '@/apis/common/model/index';
import { convertCurrencyListAoToLo, convertGlobalSetAoToLo, convertMemberLoginAoToLo } from '@/apis/common/model/index';
import { useMessage } from '@/components/Message/index'; // 自定义封装的message

enum Api {
	orderService = 'orderService',
	cmsService = 'cmsService',
	contentService = 'contentService',
	getCurrencyList = '/PolarisOrder/channel/currency',
	getGlobalSetUrl = '/rest/polaris/globalset',
	memberLoginUrl = '/rest/member/login',
	memberGuestLogin = '/rest/member/guestlogin',
	memberLogoutUrl = '/rest/member/logout',
	memberRegisterUrl = '/rest/member/register',
	contactUsSavaUrl = '/rest/contactus/save',
	countryListUrl = '/rest/airport/countrylist',
	memberFamilyListUrl = 'rest/freqcontact/ffList',
	getMemberInfoUrl = 'rest/member/memberInfo',
	saveMemberInfoUrl = 'rest/member/saveMemberInfo',
	deleteFreqContactUrl = 'rest/freqcontact/ffDelete',
	saveFreqContactUrl = 'rest/freqcontact/ffSave',
	getFreqContactDetailUrl = 'rest/freqcontact/ffInfo',
	getOrderPendingPayUrl = '/rest/order/pendingPay'
}

// 获取币种列表
export const getCurrencyListApi = async (params: { cid: string; }) => {
	const res = await myFetchRequestApi<CurrencyListAo>(
		Api.orderService,
		true,
		Api.getCurrencyList,
		{
			method: 'POST',
			params
		});
	return convertCurrencyListAoToLo(res);
};

// 获取国家列表
export const getCountryListApi = async () => {
	const res = await myFetchRequestApi<CurrencyListAo>(
		Api.contentService,
		true,
		Api.countryListUrl,
		{
			method: 'GET',
		});
	return convertReturnResultLoToAo(res.data);
};
// 获取语言接口列表
export const getGlobalSetApi = async (params: { lang: string, currency: string, }) => {
	const res = await myFetchRequestApi(
		Api.contentService,
		true,
		Api.getGlobalSetUrl,
		{
			method: 'GET',
			params
		});
	return convertGlobalSetAoToLo(res.data);
};
// 游客登录
export const memberGuestLoginApi = async (params: {}) => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.memberGuestLogin,
		{
			method: 'POST',
			params
		});
	return res.data;
};

// 会员登录接口
export const memberLoginApi = async (params: { email: string, password: string; }) => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.memberLoginUrl,
		{
			method: 'POST',
			params
		});
	if (res) {
		if (res.status === -1) {
			return useMessage().error(res.msg);
		}
		return convertMemberLoginAoToLo(res.data);
	}
};
// 退出登录
export const memberLogoutApi = async (params: {}) => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.memberLogoutUrl,
		{
			method: 'GET',
			params
		});
	return convertReturnResultLoToAo(res);
};
// 注册
export const memberRegisterApi = async (params: RegisterFormAo) => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.memberRegisterUrl,
		{
			method: 'POST',
			params
		});
	return convertReturnResultLoToAo(res);
};
// 获取常用乘机人信息
export const memberFamilyListApi = async () => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.memberFamilyListUrl,
		{
			method: 'POST',
		});
	return convertReturnResultLoToAo(res.data);
};
// 联系我们
export const contactUsSavaApi = async (params: {}) => {
	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.contactUsSavaUrl,
		{
			method: 'POST',
			params
		});
	return convertReturnResultLoToAo(res);
};
// 获取账号用户信息接口
export const getMemberInfoApi = async () => {

	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.getMemberInfoUrl,
		{
			method: 'GET',
		});
	return convertReturnResultLoToAo(res);
};
// 保存账号用户信息
export const saveMemberInfoApi = async (params: any) => {

	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.saveMemberInfoUrl,
		{
			method: 'POST',
			params,
		});
	return convertReturnResultLoToAo(res);
};
// 保存常用乘客信息
export const saveFreqContactApi = async (params: any) => {

	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.saveFreqContactUrl,
		{
			method: 'POST',
			params,
		});
	return convertReturnResultLoToAo(res);
};
// 删除常用乘客
export const deleteFreqContactApi = async (params: any) => {

	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.deleteFreqContactUrl,
		{
			method: 'GET',
			params,
		});
	return convertReturnResultLoToAo(res);
};
export const getOrderPendingPayApi = async (params: any) => {

	const res = await myFetchRequestApi(
		Api.cmsService,
		true,
		Api.getOrderPendingPayUrl,
		{
			method: 'POST',
			params,
		});
	return convertReturnResultLoToAo(res);
};
function convertReturnResultLoToAo(res: any) {
	if (res) {
		if (res.status === -1) {
			return useMessage().error(res.msg);
		}
		return res;
	} else {
		const res = {
			status: '-1',
		};
		return res;
	}
}
